<template>
  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
  <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css" rel="stylesheet" />
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
  <div>
    <!-- Cabecera -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
<!-- Cabecera Superior (Siempre visible) -->
  <div class="bg-white border-bottom shadow-sm py-3 mb-4">
    <div class="container-fluid px-4">
      <div class="row align-items-center">
        <div class="col-9">
          <div class="d-flex align-items-center gap-4">
            <div>
              <span class="badge bg-primary fs-5 px-3 py-2">Nº</span>
              <h4 class="d-inline ms-2 mb-0 fw-bold text-primary">{{ datoPlanilla.numero }}</h4>
            </div>
            <div>
              <span class="text-muted small d-block">Cédula</span>
              <strong class="fs-5">{{ datoPlanilla.cedula }}</strong>
            </div>
            <div class="flex-grow-1">
              <span class="text-muted small d-block">Paciente</span>
              <strong class="fs-5">{{ datoPlanilla.nombre }}</strong>
            </div>
          </div>
        </div>
        <div class="col-3 text-end">
          <button
            class="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
            @click.prevent="mostrarOcultarBloque"
          >
            <span class="material-symbols-outlined">
              {{ mostrarBloque ? "expand_less" : "expand_more" }}
            </span>
            {{ mostrarBloque ? "Menos información" : "Más información" }}
          </button>
        </div>
      </div>
    </div>
  </div>

              <div class="mb-1">
                <div class="row">
                  <div class="col-12">
                    <p v-if="esDiaSabado(datoPlanilla.fechaDesde)" class="texto-aviso">
                      La fecha de atención corresponde a un día sábado
                    </p>
                    <p v-if="esDiaDomingo(datoPlanilla.fechaDesde)" class="texto-aviso">
                      La fecha de atención corresponde a un día domingo
                    </p>
                  </div>
                </div>
              </div>

          <div v-if="mostrarBloque" class="mb-3">
            <div class="modal-body">

              <!-- Diagnósticos 1 y 2 -->
              <div class="mb-1">
                <div class="row">
                  <div class="col-11">
                    <div class="mb-1" v-for="n in 2" :key="'diag' + n">
                      <div class="row">
                        <div class="col-1">
                          <label :for="'diag' + n" class="form-label fw-bold">Diag {{ n }}</label>
                        </div>
                        <div class="col-2">
                          <input type="text" class="form-control me-2" :id="'diag' + n"
                            v-model="datoPlanilla['diag' + n]" :required="n < 3" readonly />
                        </div>
                        <div class="col-7">
                          <input type="text" class="form-control" v-model="nombre_diag[n]" disabled />
                        </div>
                        <div class="col-1">
                          <span
                            v-if="procesoAM"
                            @click="abrirModalDiagnosticos('diag' + n)"
                            data-bs-toggle="modal"
                            data-bs-target="#ModalDiagnosticoLOV"
                            title="Buscar diagnóstico"
                            class="btn btn-outline-info d-inline-flex align-items-center justify-content-center rounded-circle"
                            style="width:40px; height:40px; cursor:pointer;"
                          >
                            <span class="material-symbols-outlined" style="font-size:24px;">search</span>
                          </span>
                        </div>
                        <div class="col-1 d-flex align-items-center justify-content-center">
                          <div class="form-check form-switch">
                            <input
                              v-if="procesoAM"
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              v-model="datoPlanilla['controlDiag' + n]"
                              :true-value="1"
                              :false-value="0"
                              :title="datoPlanilla['controlDiag' + n] === 1 ? 'Desactivar' : 'Activar'"
                              @change="onToggleDiag(n)"
                              v-bind="datoPlanilla['controlDiag' + n] === 0
                                ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#ModalDiagnosticoLOV' }
                                : {}"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1">
                    <div class="d-flex justify-content-end mt-2">
                      <button
                        class="btn btn-outline-secondary d-inline-flex align-items-center gap-1 mt-2"
                        @click.prevent="mostrarOcultarDiagExtra"
                        style="padding-top:0.1rem; padding-bottom:0.1rem; padding-left:0.5rem; padding-right:0.5rem;"
                      >
                        <span class="material-icons" style="font-size:1.1rem">
                          {{ mostrarDiagExtra ? "remove_circle_outline" : "add_circle_outline" }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Diagnósticos 3, 4, 5 -->
              <div class="mb-1">
                <div class="row">
                  <div class="col-11">
                    <div v-if="mostrarDiagExtra" class="mt-1">
                      <div class="mb-1" v-for="n in [3, 4, 5]" :key="'diag' + n">
                        <div class="row">
                          <div class="col-1">
                            <label :for="'diag' + n" class="form-label fw-bold">Diag {{ n }}</label>
                          </div>
                          <div class="col-2">
                            <input type="text" class="form-control me-2" :id="'diag' + n"
                              v-model="datoPlanilla['diag' + n]" :required="n < 3" readonly />
                          </div>
                          <div class="col-7">
                            <input type="text" class="form-control" v-model="nombre_diag[n]" disabled />
                          </div>
                          <div class="col-1">
                            <span
                              v-if="procesoAM"
                              @click="abrirModalDiagnosticos('diag' + n)"
                              data-bs-toggle="modal"
                              data-bs-target="#ModalDiagnosticoLOV"
                              title="Buscar diagnóstico"
                              class="btn btn-outline-info d-inline-flex align-items-center justify-content-center rounded-circle"
                              style="width:40px; height:40px; cursor:pointer;"
                            >
                              <span class="material-symbols-outlined" style="font-size:24px;">search</span>
                            </span>
                          </div>
                          <div class="col-1 d-flex align-items-center justify-content-center">
                            <div class="form-check form-switch">
                              <input
                                v-if="procesoAM"
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                v-model="datoPlanilla['controlDiag' + n]"
                                :true-value="1"
                                :false-value="0"
                                :title="datoPlanilla['controlDiag' + n] === 1 ? 'Desactivar' : 'Activar'"
                                @change="onToggleDiag(n)"
                                v-bind="datoPlanilla['controlDiag' + n] === 0
                                  ? { 'data-bs-toggle': 'modal', 'data-bs-target': '#ModalDiagnosticoLOV' }
                                  : {}"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1"></div>
                </div>
              </div>

              <!-- Aut./Cod. Val. -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="codigoVal" class="form-label fw-bold">C.V.</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="codigoVal" name="codigoVal"
                      v-model="datoPlanilla.codigoVal" />
                  </div>
                  <div class="col-2">
                  </div>
                  <div class="col-3">
                  </div>
                  <div class="col-1">
                    <!-- Botón para abrir -->
                    <button
                      type="button"
                      class="btn btn-outline-info btn-sm" 
                      @click="abrirObsPlanilla(datoPlanilla.idPlanilla)"
                      title="Observaciones del Financiador">
                      <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">
                        assignment
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Médico -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="cedulaMedico" class="form-label fw-bold">Médico</label>
                  </div>
                  <div class="col-2">
                    <input type="text" class="form-control" id="cedulaMedico" name="cedulaMedico"
                      v-model="datoPlanilla.cedulaMedico" />
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control" id="nombreMedico" name="nombreMedico"
                      v-model="datoPlanilla.nombreMedico" />
                  </div>
                </div>
              </div>

              <hr />

              <!-- Fechas, estado y botones -->
              <div class="mb-1">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha desde</label>
                    <input type="date" class="form-control" id="fechaDesde" name="fechaDesde"
                      v-model="datoPlanilla.fechaDesde"
                      :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga, 1)"
                      :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga, 2)"
                      required />
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Hora d.</label><br />
                    <span>{{ datoPlanilla.horaDesde }}</span>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha hasta</label>
                    <input type="date" class="form-control" id="fechaHasta" name="fechaHasta"
                      v-model="datoPlanilla.fechaHasta"
                      :min="getFormattedDateISO(datoPlanilla.fechaDesdeCarga, 2)"
                      :max="getFormattedDateISO(datoPlanilla.fechaHastaCarga, 2)"
                      required />
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Hora h.</label><br />
                    <span>{{ datoPlanilla.horaHasta }}</span>
                  </div>
                  <div class="col-2">
                    <label class="form-label fw-bold">Estado</label><br />
                    <span v-if="consultaAM">{{ datoPlanilla.estadoAud }}</span>
                    &nbsp;
                    <button type="button" v-if="consultaAM" @click="marcarPendiente('estadoAud')"
                      title="Restablecer a estado PENDIENTE">
                      <span class="material-symbols-outlined">replay</span>
                    </button>
                    <span v-if="consultaGD">{{ datoPlanilla.estadoDoc }}</span>
                    &nbsp;
                    <button type="button" v-if="consultaGD" @click="marcarPendiente('estadoDoc')"
                      title="Restablecer a estado PENDIENTE">
                      <span class="material-symbols-outlined">replay</span>
                    </button>
                  </div>
                  <div class="col-1"></div>
                  <div class="col-1">
                    <button v-if="procesoAM || procesoGD" type="button"
                      class="btn btn-outline-primary" @click="guardarPlanilla()" title="Actualizar">
                      <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">update</span>
                    </button>
                  </div>
                  <div class="col-1">
                    <button class="btn btn-outline-danger"
                      @click="planillaPDF(datoPlanilla.idPlanilla)"
                      title="Generar archivo .pdf de la atención médica">
                      <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">picture_as_pdf</span>
                    </button>
                  </div>
                  <div class="col-1">
                    <button v-if="idPerfil == 17 && datoPlanilla.estado == 1" type="button"
                      class="btn btn-outline-secondary"
                      @click="anularPlanilla(datoPlanilla.idPlanilla)"
                      title="Anular atención médica">
                      <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">delete</span>
                    </button>

                    <button v-else-if="idPerfil == 17 && datoPlanilla.estado == 0" type="button"
                      class="btn btn-outline-success"
                      @click="activarPlanilla(datoPlanilla.idPlanilla)"
                      title="Activar atención médica">
                      <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">restore_from_trash</span>
                    </button>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </form>
		
            <!-- Plantillas y revisión -->
            <div>
              <div class="mb-1">
                <div class="input-group">
                  <input v-if="procesoAM" type="text" class="form-control"
                    v-model="searchText" @input="filterPlantillas" placeholder="Consultar plantilla..." />
                  <select v-if="procesoAM" class="form-select" id="plantillaSelect" v-model="selectedPlantilla">
                    <option disabled value="">Seleccione una plantilla</option>
                    <option v-for="plantilla in filteredPlantillas" :key="plantilla.idPlantilla" :value="plantilla">
                      {{ plantilla.nombre }}
                    </option>
                  </select>
                  <button v-if="procesoAM" type="button" class="btn btn-primary"
                    @click="registrarElementos" title="Aplicar plantilla">
                    <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">add_circle</span> Plantilla
                  </button>
                  <button v-if="procesoAM" type="button" class="btn btn-primary"
                    @click="eliminarElementos" title="Quitar plantilla">
                    <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">do_not_disturb_on</span> Plantilla
                  </button>
                  <button v-if="procesoAM || procesoGD" type="button" class="btn btn-success"
                    @click="registrarRevision" title="Aplicar revisión">
                    <span class="material-symbols-outlined" style="font-size:24px; cursor:pointer">task_alt</span> Revisión
                  </button>
                </div>
              </div>
            </div>
		
      </div>
    </div>

    <br />

<!-- Tabs -->
<div class="tab-bar">
  <button class="tablink" @click="showTable = 'planilladet'"
    :class="{ 'active-tab': showTable === 'planilladet' }">
    <span class="material-symbols-outlined">stacks</span> Detalle
  </button>

  <button class="tablink" @click="showTable = 'archivopla'"
    :class="{ 'active-tab': showTable === 'archivopla' }">
    <span class="material-symbols-outlined">description</span> Archivos
  </button>

  <button class="tablink" @click="showTable = 'valArchivos'"
    v-if="idUsuario==1"
    :class="{ 'active-tab': showTable === 'valArchivos' }">
    <span class="material-symbols-outlined">verified</span> Validación
  </button>
  
  <!-- Funcionalidades -->
  <div v-if="procesoAM" class="tab-dropdown" ref="dropFunc">
    <button class="tablink" @click="setTab('registroCodigos')"
      :class="{ 'active-tab': showTable === 'registroCodigos' }">
      <span class="material-symbols-outlined">build_circle</span> Funcionalidades
    </button>
  </div>

  <!-- Dropdown: Observaciones (visible si consultaAM o consultaGD) -->
  <div v-if="consultaAM || consultaGD" class="tab-dropdown" ref="dropObs">
    <button class="tablink tab-dropdown-btn"
      :class="{ 'active-tab': ['observacionAM','observacionGD','observacionRespuesta'].includes(showTable) }"
      @click="toggleDropdown('obs')">
      <span class="material-symbols-outlined">clinical_notes</span>
      Observaciones
      <span class="material-symbols-outlined" style="font-size:16px">expand_more</span>
    </button>
    <div class="tab-dropdown-menu" v-show="dropdownAbierto === 'obs'">
      <button v-if="consultaAM" class="tab-dropdown-item"
        :class="{ 'active-item': showTable === 'observacionAM' }"
        @click="setTab('observacionAM')">
        <span class="material-symbols-outlined">medical_information</span> Auditoría Médica
      </button>
      <button v-if="consultaGD" class="tab-dropdown-item"
        :class="{ 'active-item': showTable === 'observacionGD' }"
        @click="setTab('observacionGD')">
        <span class="material-symbols-outlined">folder_managed</span> Gestión Documental
      </button>
      <button v-if="consultaAM" class="tab-dropdown-item"
        :class="{ 'active-item': showTable === 'observacionRespuesta' }"
        @click="setTab('observacionRespuesta')">
        <span class="material-symbols-outlined">clinical_notes</span> Obs. y Respuestas
      </button>
    </div>
  </div>

<!-- Otras opciones -->
<div class="tab-dropdown" ref="dropSup">
  <button class="tablink tab-dropdown-btn"
    :class="{ 'active-tab': ['auditoriaPlanilla', 'otrasAtenciones', 'planilladetact'].includes(showTable) }"
    @click="toggleDropdown('sup')">
    <span class="material-symbols-outlined">manage_accounts</span>
    Otras opciones
    <span class="material-symbols-outlined" style="font-size:16px">expand_more</span>
  </button>
  <div class="tab-dropdown-menu" v-show="dropdownAbierto === 'sup'">
    <button
      v-if="supervisorAM"
      class="tab-dropdown-item"
      :class="{ 'active-item': showTable === 'auditoriaPlanilla' }"
      @click="setTab('auditoriaPlanilla')">
      <span class="material-symbols-outlined">folder_copy</span> Inf. auditoría
    </button>
    <button
      class="tab-dropdown-item"
      :class="{ 'active-item': showTable === 'otrasAtenciones' }"
      @click="setTab('otrasAtenciones')">
      <span class="material-symbols-outlined">folder_copy</span> Otras atenciones
    </button>
    <button
      v-if="supervisorAM"
      class="tab-dropdown-item"
      :class="{ 'active-item': showTable === 'planilladetact' }"
      @click="setTab('planilladetact')">
      <span class="material-symbols-outlined">toggle_off</span> Activar detalle
    </button>
    <button
      v-if="supervisorAM"
      class="tab-dropdown-item"
      @click="inactivarDetallesPlanilla()">
      <span class="material-symbols-outlined">block</span> Inactivar detalles
    </button>
  </div>
</div>
  
</div>

    <!-- Contenido tabs -->
    <div v-if="showTable === 'planilladet'">
      <PlanillaDet
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoPlanilla.idPrestador)"
        :p_idServicio="Number(p_idServicio)"
        :p_estadoTramite="p_estadoTramite"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
        :p_fechaDesde="normalizeDate(datoPlanilla.fechaDesde)"
        :p_fechaHasta="normalizeDate(datoPlanilla.fechaHasta)"
        :p_tipo="'M'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
        :p_tipoConsulta="p_tipoConsulta"
      />
      <ArchivoPla
        ref="archivoPlaVisor"
        :p_idTramite="Number(p_idTramite)"
        :p_idPlanilla="Number(p_idPlanilla)"
      />
    </div>
    <div v-if="showTable === 'archivopla'">
      <ArchivoPlaDatos
        :p_idTramite="Number(p_idTramite)"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
        :p_cedula="datoPlanilla.cedula"
        :p_fechaDesde="datoPlanilla.fechaDesde"
        :p_fechaHasta="datoPlanilla.fechaHasta"
        :p_diag1="datoPlanilla.diag1"
        :p_diag2="datoPlanilla.diag2"
        :p_diag3="datoPlanilla.diag3"
        :p_diag4="datoPlanilla.diag4"
        :p_diag5="datoPlanilla.diag5"
      />
<hr>
<div class="d-flex justify-content-between align-items-center mb-2">
  <h6 class="mb-0">Carga de Archivos</h6>
  <button
    class="btn btn-sm btn-primary"
    @click="mostrarModalCarga = true"
    title="Subir archivo"
  >
    <span class="material-icons align-middle" style="font-size:16px">upload_file</span>
  </button>
</div>

<!-- Modal de carga -->
<ArchivoPlaUploadModal
  v-if="mostrarModalCarga"
  :p_idTramite="p_idTramite"
  :p_idPlanilla="p_idPlanilla"
  @cerrar="mostrarModalCarga = false"
  @cargado="onArchivoCargado"
/>
<hr>
    </div>
    <div v-if="showTable === 'valArchivos'">
      <ValidacionDocumentos
        :p_idTramite="Number(p_idTramite)"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
      />
    </div>
    <div v-if="showTable === 'observacionAM'">
      <PlaObs :p_idPlanilla="Number(p_idPlanilla)" :p_tipo="'M'"
        :p_procesoAM="procesoAM" :p_procesoGD="procesoGD" />
    </div>
    <div v-if="showTable === 'observacionGD'">
      <PlaObs :p_idPlanilla="Number(p_idPlanilla)" :p_tipo="'D'"
        :p_procesoAM="procesoAM" :p_procesoGD="procesoGD" />
    </div>
    <div v-if="showTable === 'otrasAtenciones'">
      <PlanillaInfo
        :idPrestador="Number(datoPlanilla.idPrestador)"
        :idEspecialidad="1"
        :cedula="datoPlanilla.cedula"
        :nombre="datoPlanilla.nombre" />
    </div>
    <div v-if="showTable === 'auditoriaPlanilla'">
      <ConsultaAuditoriaPlanilla :idPlanilla="Number(datoPlanilla.idPlanilla)" />
    </div>
    <div v-if="showTable === 'planilladetact'">
      <PlanillaDetAct
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoPlanilla.idPrestador)"
        :p_estadoTramite="p_estadoTramite"
        :p_idPlanilla="Number(p_idPlanilla)"
        :p_numero="datoPlanilla.numero"
        :p_tipo="'M'"
        :p_procesoAM="procesoAM"
        :p_procesoGD="procesoGD"
        :p_tipoConsulta="p_tipoConsulta"
      />
    </div>
    <DiagnosticoLOV @DatosDiagnostico="asignarDiagnostico" />
    <div v-if="showTable === 'observacionRespuesta'">
      <PlanillaObs :idPlanilla="Number(datoPlanilla.idPlanilla)" />
    </div>

    <div v-if="showTable === 'registroCodigos'">
      <Funcionalidades
        :idPlanilla="p_idPlanilla"
        :idPrestador="idEmpresa"
        :fechaDesde="datoPlanilla.fechaDesde"
        :fechaHasta="datoPlanilla.fechaHasta"
        :idUsuario="idUsuario"
        :condicion="procesoAM && !!datoPlanilla.fechaDesde && !!datoPlanilla.fechaHasta"
        @cargado="getData"
        @anulado="getData"
      />
    </div>

  </div>
<!-- Modal -->
<div v-if="modalObsPlanillaVisible" class="modal-overlay" @click.self="cerrarObsPlanilla">
  <div class="modal-contenido card shadow-lg">
    <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center py-2">
      <span class="fw-bold small">
        <span class="material-symbols-outlined" style="font-size: 16px; vertical-align: middle;">
          assignment
        </span>
        Observaciones — Planilla {{ idPlanillaObs }}
      </span>
      <button class="btn btn-sm btn-outline-light" @click="cerrarObsPlanilla">
        <span class="material-symbols-outlined" style="font-size: 16px;">close</span>
      </button>
    </div>
    <div class="card-body p-2" style="max-height: 70vh; overflow-y: auto;">
      <PlanillaObs :idPlanilla="idPlanillaObs" />
    </div>
  </div>
</div>
</template>

<script>
import config from '@/config';
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { esSabado, esDomingo } from "@/modules/dateUtils.js";
import { registrarBitacoraTramite } from "@/modules/bitacoraTramite.js";
import PlanillaDet from "../forms/PlanillaDet.vue";
import PlanillaDetAct from "../forms/PlanillaDetAct.vue";
import ArchivoPla from "../forms/ArchivoPla.vue";
import ArchivoPlaDatos from "../forms/ArchivoPlaDatos.vue";
import ValidacionDocumentos from "@/components/ValidacionDocumentos.vue";
import PlanillaInfo from "../forms/PlanillaInfo.vue";
import PlaObs from "../forms/PlaObs.vue";
import ConsultaAuditoriaPlanilla from '@/views/reportes/ConsultaAuditoriaPlanilla.vue';
import DiagnosticoLOV from "@/components/lovs/DiagnosticoLOV.vue";
import Funcionalidades from "@/components/Funcionalidades.vue";
import PlanillaObs from "@/components/PlanillaObs.vue";
import ArchivoPlaUploadModal from "@/components/ArchivoPlaUploadModal.vue";
import Swal from "sweetalert2";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;

export default {
  components: {
    PlanillaDet,
    PlanillaDetAct,
    ArchivoPla,
    ArchivoPlaDatos,
    ValidacionDocumentos,
    PlaObs,
    PlanillaInfo,
    ConsultaAuditoriaPlanilla,
    DiagnosticoLOV,
    Funcionalidades,
    PlanillaObs,
    ArchivoPlaUploadModal,
  },
  data() {
    return {
      planillas:            [],
      plantillas:           [],
      datoPlanilla:         {},
      nombreBusqueda:       "",
      titulo:               "",
      modalWindow:          true,
      p_idTramite:          0,
      p_idServicio:         0,
      p_estadoTramite:      0,
      p_idPlanilla:         0,
      p_tipoConsulta:       "",
      idPerfil:             0,
      idUsuario:            0,
      showTable:            "",
      tramites:             [],
      nombre_diag:          { 1: null, 2: null, 3: null, 4: null, 5: null },
      filteredPlantillas:   [],
      searchText:           "",
      selectedPlantilla:    null,
      mensaje:              "",
      success:              false,
      mostrarBloque:        true,
      mostrarDiagExtra:     false,
      pendientesRevision:   0,
      tipo:                 "",
      idEmpresa:            0,
      campoDiagnosticoActivo: '',
      modalObsPlanillaVisible: false,
      idPlanillaObs: null,
      dropdownAbierto: null,
      verReportes: 0,
      mostrarModalCarga: false,
    };
  },
  computed: {
    supervisorAM() {
      return (
        this.idPerfil == 17 &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaAM() {
      return (
        (this.idPerfil == 17 || this.idPerfil == 18 || this.idPerfil == 22) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    consultaGD() {
      return (
        (this.idPerfil == 19 || this.idPerfil == 20) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    procesoAM() {
      return (
        (this.idPerfil == 17 || this.idPerfil == 22 ||
          ((this.idPerfil == 18 && this.idUsuario == this.datoPlanilla.idUsuarioMed) || 
           (this.verReportes > 0 ))) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    procesoGD() {
      return (
        (this.idPerfil == 19 ||
          (this.idPerfil == 20 && this.idUsuario == this.datoPlanilla.idUsuarioDoc)) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    AM_GD() {
      return (
        (this.idPerfil == 17 || this.idPerfil == 18 ||
          this.idPerfil == 19 || this.idPerfil == 20 || this.idPerfil == 22) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
  },
  mounted() {
    const q = this.$route.query;
    if (q.idPlanilla) {
      this.p_idTramite     = Number(q.idTramite);
      this.p_idServicio    = Number(q.idServicio);
      this.p_estadoTramite = q.estadoTramite;
      this.p_idPlanilla    = Number(q.idPlanilla);
      this.p_tipoConsulta  = q.tipoConsulta;
    } else {
      this.p_idTramite     = Number(this.$route.params.p_idtramite);
      this.p_idServicio    = Number(this.$route.params.p_idservicio);
      this.p_estadoTramite = this.$route.params.p_estadotramite;
      this.p_idPlanilla    = Number(this.$route.params.p_idplanilla);
      this.p_tipoConsulta  = this.$route.params.p_tipoconsulta;
    }

    this.idEmpresa  = Number(window.sessionStorage.getItem("idEmpresa"));
    this.idPerfil   = Number(window.sessionStorage.getItem("idPerfil"));
    this.idUsuario  = Number(window.sessionStorage.getItem("idUsuario"));
    this.tipo       = (this.idPerfil == 17 || this.idPerfil == 18 || this.idPerfil == 22) ? "M" : "D";
    this.verReportes = window.sessionStorage.getItem("verReportes");

    this.getData();
    this.fetchPlantillas();
    document.addEventListener('click', this.cerrarDropdowns);
  },
  beforeUnmount(){
    document.removeEventListener('click', this.cerrarDropdowns);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getFormattedDateISO(date, tipoFecha) {
      if (this.p_idServicio == 2 && tipoFecha == 1) {
        const [year, month, day] = String(date).split('-').map(Number);
        const d = new Date(year - 1, month - 1, day);
        return dateFormat.getFormattedDateISO(d);
      }
      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        return date.substring(0, 10);
      }
      return dateFormat.getFormattedDateISO(date);
    },
    normalizeDate(dateString) {
      if (!dateString) return new Date();
      const [year, month, day] = dateString.split('-');
      return new Date(`${year}-${month}-${day}T00:00:00.000-05:00`);
    },
    esDiaSabado(fecha)  { return esSabado(fecha);  },
    esDiaDomingo(fecha) { return esDomingo(fecha); },
    mostrarOcultarBloque()    { this.mostrarBloque    = !this.mostrarBloque;    },
    mostrarOcultarDiagExtra() { this.mostrarDiagExtra = !this.mostrarDiagExtra; },

    async getData() {
      await api.get("/vwplanillaexts/" + this.p_idPlanilla)
        .then((response) => {
          this.datoPlanilla = response.data;
          if (response.data.estadoTramite) {
            this.p_estadoTramite = response.data.estadoTramite;
          }
          this.datoPlanilla.fechaDesde = dateFormat.getFormattedDateISO(this.datoPlanilla.fechaDesde);
          this.datoPlanilla.fechaHasta = dateFormat.getFormattedDateISO(this.datoPlanilla.fechaHasta);
          document.title = `Allikamay - ${this.p_idTramite} - Nº: ${this.datoPlanilla.numero}`;
          this.fetchDiagnosticos();
          this.verErrores(this.p_idTramite, this.datoPlanilla.numero);
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },

    validarForm() {
      const fields = ["idTramite","numero","cedula","nombre","diag1","fechaDesde","fechaHasta","estadoAud"];
      return validarForm(this.datoPlanilla, fields, fields);
    },

    async guardarPlanilla() {
      if (!this.datoPlanilla.diag2 && this.tipo == 'M') {
        Swal.fire("Error!", "El segundo diagnóstico no puede ser nulo", "error");
        return;
      }
      if (this.validarForm() === 1) {
        try {
          this.datoPlanilla.idUsuarioAct = this.idUsuario;
          this.datoPlanilla.fechaAct     = new Date();
          await api.post('/planillas', this.datoPlanilla);
          Swal.fire("Éxito", "Planilla actualizada exitosamente!", "success");
        } catch(error) {
          const mensajeError = error.response?.data?.mensaje || "Error en la solicitud";
          Swal.fire("Error", mensajeError, "error");
        }
      }
    },

    async anularPlanilla(p_idPlanilla) {
      try {
        await api.post('/procedimientos/anular-planilla', null, { params: { idPlanilla: p_idPlanilla } });
        await Swal.fire("Éxito", "Planilla anulada exitosamente!", "success");
        await this.getData();
      } catch {
        Swal.fire("Error!", "Inténtelo de nuevo!", "error");
      }
    },

    async activarPlanilla(p_idPlanilla) {
      try {
        await api.post('/procedimientos/activar-planilla', null, { params: { idPlanilla: p_idPlanilla } });
        await Swal.fire("Éxito", "Planilla activada exitosamente!", "success");
        await this.getData();
      } catch {
        Swal.fire("Error!", "Inténtelo de nuevo!", "error");
      }
    },

    async fetchNombreDiagnostico(codigo) {
      try {
        const response = await api.get(`/vwdiagnosticos/codigo-sin-punto/${codigo}`);
        const diagnosticos = response.data;
        return Array.isArray(diagnosticos) && diagnosticos.length > 0
          ? diagnosticos[0].nombre
          : "Diagnóstico no encontrado";
      } catch {
        return "Error al cargar";
      }
    },

    async fetchDiagnosticos() {
      const codigos = [
        this.datoPlanilla.diag1,
        this.datoPlanilla.diag2,
        this.datoPlanilla.diag3,
        this.datoPlanilla.diag4,
        this.datoPlanilla.diag5,
      ];
      const nombres = await Promise.all(
        codigos.map(codigo => codigo ? this.fetchNombreDiagnostico(codigo) : null)
      );
      [1,2,3,4,5].forEach((n, i) => { this.nombre_diag[n] = nombres[i]; });
    },

    fetchPlantillas() {
      api.get(`/vwplantillas/idempresa/${this.idEmpresa}`)
        .then((response) => {
          this.plantillas        = response.data;
          this.filteredPlantillas = response.data;
        })
        .catch((error) => console.error("Error fetching plantillas:", error));
    },

    filterPlantillas() {
      this.filteredPlantillas = this.plantillas.filter(p =>
        p.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },

    async registrarElementos() {
      if (this.datoPlanilla.idPlantilla == null) {
        if (this.selectedPlantilla != null) {
          try {
            const response = await api.post("/planillas/registrar-elementos-plantilla", null, {
              params: { idPlanilla: this.p_idPlanilla, idPlantilla: this.selectedPlantilla.idPlantilla },
            });
            this.getData();
            Swal.fire("Éxito", response.data, "success");
          } catch (error) {
            Swal.fire("Error", error.response?.data || "Ocurrió un error.", "error");
          }
        } else {
          Swal.fire({ title:"Atención", text:"Por favor, seleccione una plantilla antes de continuar.",
            icon:"warning", confirmButtonText:"Entendido", confirmButtonColor:"#f39c12" });
        }
      } else {
        Swal.fire({ title:"Atención", text:"La planilla ya tiene asignada una plantilla.",
          icon:"warning", confirmButtonText:"Entendido", confirmButtonColor:"#f39c12" });
      }
    },

    async eliminarElementos() {
      if (this.datoPlanilla.idPlantilla != null) {
        try {
          const response = await api.post("/planillas/eliminar-elementos-plantilla", null, {
            params: { idPlanilla: this.p_idPlanilla },
          });
          this.getData();
          Swal.fire("Éxito", response.data, "success");
        } catch (error) {
          Swal.fire("Error", error.response?.data || "Ocurrió un error.", "error");
        }
      } else {
        Swal.fire({ title:"Atención", text:"Esta planilla no tiene una plantilla asignada.",
          icon:"warning", confirmButtonText:"Entendido", confirmButtonColor:"#f39c12" });
      }
    },

    async registrarRevision() {
      if (!this.datoPlanilla.diag2 && this.tipo == 'M') {
        Swal.fire("Error!", "El segundo diagnóstico no puede ser nulo", "error");
        return;
      }
      if (this.validarForm() === 1) {
        const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
        try {
          let actividad  = null;
          const now      = new Date();
          const offset   = -5 * 60 * 60 * 1000;
          const localDate = new Date(now.getTime() + offset);
          const fechaISO  = localDate.toISOString().split('.')[0];

          if ([17, 18, 22].includes(idPerfil)) {
            actividad = "M";
            this.datoPlanilla.estadoAud    = "REVISADA";
            this.datoPlanilla.idUsuarioMed = this.idUsuario;
            this.datoPlanilla.fechaAud     = fechaISO;
          } else if ([19, 20].includes(idPerfil)) {
            actividad = "D";
            this.datoPlanilla.estadoDoc    = "REVISADA";
            this.datoPlanilla.idUsuarioDoc = this.idUsuario;
            this.datoPlanilla.fechaDoc     = fechaISO;
          } else {
            Swal.fire("Error!", "Perfil no autorizado para esta acción", "error");
            return;
          }

          await api.post("/planillas", this.datoPlanilla);
          if (actividad) {
            await registrarBitacoraTramite(
              this.p_idTramite,
              `Planilla: ${this.datoPlanilla.numero}, Paciente: ${this.datoPlanilla.nombre}`,
              actividad
            );
          }

          const tabMap = {
            TODAS: 'planillas', PENDIENTES: 'planillasPendientes',
            REVISADAS: 'planillasRevisadas', ANULADAS: 'planillasAnuladas',
            FILTROS: 'planillasFiltros',
          };
          const targetTab = tabMap[this.p_tipoConsulta] || 'planillas';

          Swal.fire({ title:"Éxito", text:"Revisión registrada exitosamente!", icon:"success",
            timer:200, showConfirmButton:false }).then(() => {
            if (window.opener) {
              window.opener.postMessage({ action:'refreshAndSwitchTab', tab:targetTab },
                window.location.origin);
            }
            window.close();
          });
        } catch (error) {
          if ([17, 18, 22].includes(idPerfil)) {
            this.datoPlanilla.estadoAud    = "PENDIENTE";
          } else if ([19, 20].includes(idPerfil)) {
            this.datoPlanilla.estadoDoc    = "PENDIENTE";
          }
          const mensajeError = error.response?.data?.mensaje || "Error en la solicitud";
          Swal.fire("Error", mensajeError, "error");
        }
      }
    },

    abrirReporte(tipo, p_idTramite) {
      window.open(`${config.apiBaseUrl}/reportes/pdf/${tipo}/${p_idTramite}`, "_blank");
    },
    planillaPDF(p_idPlanilla) { this.abrirReporte(1, p_idPlanilla); },

    abrirModalDiagnosticos(campo) { this.campoDiagnosticoActivo = campo; },
    asignarDiagnostico(diagnostico) {
      if (this.campoDiagnosticoActivo) {
        this.datoPlanilla[this.campoDiagnosticoActivo] = diagnostico.codigo;
        const num = this.campoDiagnosticoActivo.replace('diag', '');
        this.nombre_diag[num] = diagnostico.nombre;
      }
    },
    onToggleDiag(n) {
      const control = this.datoPlanilla['controlDiag' + n];
      if (control === 1) this.abrirModalDiagnosticos('diag' + n);
      else               this.borrar(n);
    },
    borrar(n) {
      this.datoPlanilla['diag' + n] = null;
      this.nombre_diag[n]           = null;
    },
    marcarPendiente(campo) { this.datoPlanilla[campo] = 'PENDIENTE'; },
    abrirObsPlanilla(idPlanilla) {
      this.idPlanillaObs = idPlanilla;
      this.modalObsPlanillaVisible = true;
    },
    cerrarObsPlanilla() {
      this.modalObsPlanillaVisible = false;
      this.idPlanillaObs = null;
    },
  formatearMensajes(texto) {
    if (!texto) return '<span class="text-muted">Ninguno</span>';
    return texto
      .split('|')
      .filter(m => m.trim())
      .map(m => `<li>${m.trim()}</li>`)
      .join('');
  },

  async verErrores(idTramite, numero) {
    try {
      const resp = await api.get(`/vwcargaplanillas/datos-planilla/${idTramite}/${numero}`);
      const dato = Array.isArray(resp.data) ? resp.data[0] : resp.data;

      if (!dato) {
//         Swal.fire({ icon: 'warning', title: 'Sin datos', text: 'No se encontró información.' });
        return;
      }

      const { detalleErrores, detalleNovedades, solucion, nombre, cedula, numero: num } = dato;

      if ( (!detalleErrores && !detalleNovedades) || (solucion != null ? solucion : 0) == 1) return;

      Swal.fire({
        title: `Detalle — ${num} | ${cedula}`,
        icon: 'info',
        width: '700px',
        html: `
          <div style="text-align:left">
            <p class="text-muted small mb-3">${nombre}</p>

            <h6>❌ Errores</h6>
            <ul style="font-size:13px; padding-left:18px; background:#fff3f3; border-left:4px solid #dc3545; padding:10px; border-radius:4px">
              ${this.formatearMensajes(detalleErrores)}
            </ul>

            <h6 class="mt-3">⚠️ Novedades</h6>
            <ul style="font-size:13px; padding-left:18px; background:#fffbf0; border-left:4px solid #ffc107; padding:10px; border-radius:4px">
              ${this.formatearMensajes(detalleNovedades)}
            </ul>
          </div>
        `
      });
    } catch (error) {
      console.error(error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo obtener el detalle.' });
    }
  },
toggleDropdown(nombre) {
  this.dropdownAbierto = this.dropdownAbierto === nombre ? null : nombre;
},
setTab(nombre) {
  this.showTable = nombre;
  this.dropdownAbierto = null;
},
cerrarDropdowns(event) {
  const obsRef  = this.$refs.dropObs;
  const supRef  = this.$refs.dropSup;
  const funcRef = this.$refs.dropFunc;
  if (
    (!obsRef  || !obsRef.contains(event.target))  &&
    (!supRef  || !supRef.contains(event.target))  &&
    (!funcRef || !funcRef.contains(event.target))
  ) {
    this.dropdownAbierto = null;
  }
},
async inactivarDetallesPlanilla() {
  this.dropdownAbierto = null

  const { isConfirmed } = await Swal.fire({
    title:             '¿Inactivar todos los detalles?',
    text:              `Se inactivarán todos los detalles activos de la planilla N° ${this.datoPlanilla.numero}.`,
    icon:              'warning',
    showCancelButton:  true,
    confirmButtonText: 'Sí, inactivar',
    cancelButtonText:  'Cancelar',
    confirmButtonColor:'#e67e22',
    cancelButtonColor: '#6c757d',
  })
  if (!isConfirmed) return

  try {
    const { data } = await api.put(
      `/planilladets/inactivar-por-planilla/${this.p_idPlanilla}`
    )
    Swal.fire('Correcto', data.mensaje, 'success')
    this.getData()
  } catch (error) {
    // Muestra el mensaje exacto que devuelve el backend
    const mensaje = error.response?.data?.mensaje
                 || error.response?.data?.message
                 || JSON.stringify(error.response?.data)
                 || 'Error desconocido'
    console.error('Error completo:', error.response?.data)
    Swal.fire('Error', mensaje, 'error')
  }
},
  onArchivoCargado() {
    this.mostrarModalCarga = false;
    // Refresca la lista del visor de archivos
    if (this.$refs.archivoPlaVisor) {
      this.$refs.archivoPlaVisor.cargarArchivos();
    }
  },
  },
};
</script>

<style scoped>
.input-group { display:flex; gap:10px; align-items:center; }
.btn { font-size:16px; padding:10px 20px; }
.alert { margin-top:20px; padding:10px; border-radius:5px; }
.alert-success { color:#155724; background-color:#d4edda; border-color:#c3e6cb; }
.alert-danger  { color:#721c24; background-color:#f8d7da; border-color:#f5c6cb; }
.texto-rojo  { color:red; font-weight:bold; background-color:#ffe5b4; }
.texto-aviso {
  color:#b30000; font-weight:600; background-color:#fff3cd;
  padding:8px 12px; border-radius:6px; border-left:4px solid #f0ad4e; font-size:14px;
}
/* ── Modal overlay ── */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-contenido {
  width: 90%;
  max-width: 900px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 15px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
/* Dropdown */
.tab-dropdown { position: relative; }
.tab-dropdown-btn { /* hereda .tablink */ }
.tab-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  min-width: 210px;
  z-index: 200;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.1);
}
.tab-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  font-size: 15px;
  color: #343a40;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}
.tab-dropdown-item:hover { background: #f0f4ff; color: #0d6efd; }
.tab-dropdown-item.active-item { color: #0d6efd; font-weight: 500; }
</style>